import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=28faae2a&scoped=true&"
import script from "./Packages.vue?vue&type=script&lang=ts&"
export * from "./Packages.vue?vue&type=script&lang=ts&"
import style0 from "./Packages.vue?vue&type=style&index=0&id=28faae2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28faae2a",
  null
  
)

export default component.exports